"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountTransactionItemsById = exports.addAccount = exports.getAccount = exports.getAccounts = void 0;
const getAccounts = async (supabase) => {
    const { data: accounts, error } = await supabase.rpc("get_financial_accounts");
    if (!error)
        return accounts;
    return error;
};
exports.getAccounts = getAccounts;
const getAccount = async (supabase, id) => {
    const { data, error } = await supabase
        .rpc("get_financial_account_by_id", {
        a_id: id,
    })
        .single();
    if (!error) {
        const account = data;
        const { data: items, error: items_error } = await supabase.rpc("get_account_transaction_items_by_id", {
            a_id: id,
        });
        if (!items_error) {
            account.items = items;
        }
        return account;
    }
    return error;
};
exports.getAccount = getAccount;
const addAccount = async (supabase, account) => {
    const { data, error } = await supabase
        .from("finance_accounts")
        .insert(account);
    if (!error)
        return data;
    return error;
};
exports.addAccount = addAccount;
const getAccountTransactionItemsById = async (supabase, id) => {
    const { data: items, error } = await supabase.rpc("get_account_transaction_items_by_id", {
        a_id: id,
    });
    if (!error)
        return items;
    return error;
};
exports.getAccountTransactionItemsById = getAccountTransactionItemsById;
